// extracted by mini-css-extract-plugin
module.exports = {"section":"givingli-essence_section__xaF9Q","section__title":"givingli-essence_section__title__xpDmW"};